import React, { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
type NavyBackdropProps = {
  src: string;
  /** How visible the photograph is through the navy. Keep low so it blends. */
  strength?: number;
  position?: string;
};

/**
 * A photograph dissolved into MCC navy: desaturated, luminosity-blended and
 * tinted so it reads as texture, not as an image competing with the copy.
 * Place as the first child of a `relative overflow-hidden bg-[#061f38]` section.
 */
export function NavyBackdrop({
  src,
  strength = 0.28,
  position = "center"
}: NavyBackdropProps) {
  const ref = useRef<HTMLDivElement>(null);
  const reduce = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? ["0%", "0%"] : ["-8%", "8%"]);
  return <div ref={ref} aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden bg-[#1c1012]" data-id="element-309" data-mp="qmi65oxum8xu">
      <motion.img src={src} alt="" loading="lazy" style={{
      y,
      opacity: Math.min(0.95, 0.55 + strength),
      objectPosition: position
    }} className="absolute inset-[-10%] h-[120%] w-[120%] object-cover saturate-[0.6]" data-id="element-310" data-mp="3pbp9m4e3jd9z" />
      <div className="absolute inset-0 bg-[#DD2128]/55" data-id="element-311" data-mp="2xp1us9bn028" />
      <div className="absolute inset-y-0 left-0 w-2/3 bg-[#1c1012]/25" data-id="element-312" data-mp="6vmrtxax1q6o" />
    </div>;
}